import React from 'react';
import { useNavigate } from 'react-router-dom';
import { statusConfig, paymentTypeConfig, formatMoney, formatDate, isOverdue, getDaysUntilDue } from './accountingConstants';
import ActionMenu from '../common/ActionMenu';

export default function InvoicesTab({
  invoices,
  invoiceFilters,
  setInvoiceFilters,
  pagination,
  locations,
  markingPaid,
  markAsPaid
}) {
  const navigate = useNavigate();

  return (
    <div>
      {/* Filtry */}
      <div style={{
        backgroundColor: "var(--card-bg)",
        borderRadius: '6px',
        border: '1px solid var(--border)',
        padding: '0.75rem',
        marginBottom: '1rem',
        display: 'flex',
        gap: '0.5rem',
        flexWrap: 'wrap',
        alignItems: 'center'
      }}>
        <input
          type="text"
          placeholder={'🔍 Szukaj (numer, dostawca, NIP)...'}
          value={invoiceFilters.search}
          onChange={(e) => setInvoiceFilters(f => ({...f, search: e.target.value, page: 1}))}
          style={{
            flex: '1 1 200px',
            padding: '6px 10px',
            border: '1px solid var(--border)',
            borderRadius: '6px',
            backgroundColor: 'var(--card-bg)',
            color: 'var(--text)',
            fontSize: '12px'
          }}
        />
        <select
          value={invoiceFilters.status}
          onChange={(e) => setInvoiceFilters(f => ({...f, status: e.target.value, page: 1}))}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        >
          <option value="">Wszystkie statusy</option>
          {Object.entries(statusConfig).map(([key, cfg]) => (
            <option key={key} value={key}>{cfg.label}</option>
          ))}
        </select>
        <select
          value={invoiceFilters.paymentStatus}
          onChange={(e) => setInvoiceFilters(f => ({...f, paymentStatus: e.target.value, page: 1}))}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        >
          <option value="">Status płatności</option>
          <option value="paid">Opłacone</option>
          <option value="unpaid">Nieopłacone</option>
          <option value="overdue">Przeterminowane</option>
        </select>
        <input
          type="date"
          value={invoiceFilters.dateFrom}
          onChange={(e) => setInvoiceFilters(f => ({...f, dateFrom: e.target.value, page: 1}))}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        />
        <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>do</span>
        <input
          type="date"
          value={invoiceFilters.dateTo}
          onChange={(e) => setInvoiceFilters(f => ({...f, dateTo: e.target.value, page: 1}))}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        />
        <button
          onClick={() => setInvoiceFilters({ search: '', status: '', dateFrom: '', dateTo: '', paymentStatus: '', page: 1, perPage: 20 })}
          style={{
            padding: '6px 12px',
            border: '1px solid var(--text-muted)',
            color: 'var(--text-muted)',
            fontSize: '12px'
          }}
        >
          Wyczyść
        </button>
      </div>

      {/* Tabela faktur */}
      <div style={{
        backgroundColor: "var(--card-bg)",
        borderRadius: '6px',
        border: '1px solid var(--border)',
        overflow: 'hidden'
      }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
          <thead>
            <tr style={{ backgroundColor: 'var(--bg)' }}>
              <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: 600, width: '40px' }}>LP</th>
              <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Nr faktury</th>
              <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Dostawca</th>
              <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Data faktury</th>
              <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Termin płatności</th>
              <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Sposób płatności</th>
              <th style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Netto</th>
              <th style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Brutto</th>
              <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Status</th>
              <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Akcje</th>
            </tr>
          </thead>
          <tbody>
            {(Array.isArray(invoices) ? invoices : []).map((invoice, index) => {
              const status = statusConfig[invoice.status] || statusConfig.nowa;
              const overdue = isOverdue(invoice);
              const daysUntil = getDaysUntilDue(invoice.data_platnosci);

              return (
                <tr
                  key={invoice.id}
                  style={{
                    backgroundColor: overdue ? 'var(--danger-light)' : 'var(--card-bg)' ,
                    cursor: 'pointer'
                  }}
                  onClick={() => navigate(`/purchase-invoices/${invoice.id}`)}
                >
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)', textAlign: 'center', color: 'var(--text-muted)', fontSize: '11px' }}>
                    {((invoiceFilters.page - 1) * invoiceFilters.perPage) + index + 1}
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)' }}>
                    <div style={{ fontWeight: 500 }}>{invoice.numer_faktury}</div>
                    {invoice.location_id && (
                      <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>
                        {'📍'} {locations.find(l => l.id === invoice.location_id)?.nazwa || `ID: ${invoice.location_id}`}
                      </div>
                    )}
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)' }}>
                    <div>{invoice.dostawca_nazwa}</div>
                    {invoice.dostawca_nip && (
                      <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>NIP: {invoice.dostawca_nip}</div>
                    )}
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)', textAlign: 'center' }}>
                    {formatDate(invoice.data_faktury)}
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)', textAlign: 'center' }}>
                    <div style={{ color: overdue ? 'var(--danger)' : (daysUntil !== null && daysUntil <= 7 ? 'var(--warning)' : 'var(--text-secondary)') }}>
                      {formatDate(invoice.data_platnosci)}
                    </div>
                    {daysUntil !== null && invoice.status !== 'zatwierdzona' && (
                      <div style={{ fontSize: '10px', color: overdue ? 'var(--danger)' : 'var(--text-muted)' }}>
                        {overdue ? `${Math.abs(daysUntil)} dni po terminie` : `za ${daysUntil} dni`}
                      </div>
                    )}
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)', textAlign: 'center' }}>
                    {invoice.sposob_platnosci ? (
                      <span style={{
                        padding: '2px 6px',
                        backgroundColor: paymentTypeConfig[invoice.sposob_platnosci]?.color + '20' || 'var(--bg)',
                        color: paymentTypeConfig[invoice.sposob_platnosci]?.color || 'var(--text-secondary)',
                        borderRadius: '3px',
                        fontSize: '10px'
                      }}>
                        {paymentTypeConfig[invoice.sposob_platnosci]?.icon} {paymentTypeConfig[invoice.sposob_platnosci]?.label || invoice.sposob_platnosci}
                      </span>
                    ) : '-'}
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)', textAlign: 'right' }}>
                    {formatMoney(invoice.suma_netto)}
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)', textAlign: 'right', fontWeight: 600 }}>
                    {formatMoney(invoice.suma_brutto)}
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)', textAlign: 'center' }}>
                    <span style={{
                      padding: '3px 8px',
                      backgroundColor: status.bg,
                      color: status.text,
                      borderRadius: '3px',
                      fontSize: '10px',
                      fontWeight: 500
                    }}>
                      {status.label}
                    </span>
                  </td>
                  <td style={{ padding: '10px', borderBottom: '1px solid var(--border)', textAlign: 'center' }}>
                    <ActionMenu actions={[
                      invoice.status !== 'zatwierdzona' && {
                        icon: markingPaid === invoice.id ? '⏳' : '✅',
                        label: 'Zapłacono',
                        color: 'var(--success)',
                        disabled: markingPaid === invoice.id,
                        onClick: () => markAsPaid(invoice)
                      },
                      { icon: '🔍', label: 'Szczegóły', color: 'var(--info)', onClick: () => navigate(`/purchase-invoices/${invoice.id}`) },
                    ]} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>

        {(!Array.isArray(invoices) || invoices.length === 0) && (
          <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>
            Brak faktur do wyświetlenia
          </div>
        )}

        {/* Paginacja */}
        {pagination.pages > 1 && (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            padding: '1rem',
            borderTop: '1px solid var(--border)'
          }}>
            <button
              onClick={() => setInvoiceFilters(f => ({...f, page: Math.max(1, f.page - 1)}))}
              disabled={invoiceFilters.page === 1}
              style={{
                padding: '6px 12px',
                border: invoiceFilters.page === 1 ? '1px solid var(--border)' : '1px solid var(--info)',
                color: invoiceFilters.page === 1 ? 'var(--text-muted)' : 'var(--info)',
                cursor: invoiceFilters.page === 1 ? 'not-allowed' : undefined,
                fontSize: '12px'
              }}
            >
              {'←'} Poprzednia
            </button>
            <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
              Strona {invoiceFilters.page} z {pagination.pages} ({pagination.total} faktur)
            </span>
            <button
              onClick={() => setInvoiceFilters(f => ({...f, page: Math.min(pagination.pages, f.page + 1)}))}
              disabled={invoiceFilters.page === pagination.pages}
              style={{
                padding: '6px 12px',
                border: invoiceFilters.page === pagination.pages ? '1px solid var(--border)' : '1px solid var(--info)',
                color: invoiceFilters.page === pagination.pages ? 'var(--text-muted)' : 'var(--info)',
                cursor: invoiceFilters.page === pagination.pages ? 'not-allowed' : undefined,
                fontSize: '12px'
              }}
            >
              Następna {'→'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
